import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=a31c4466&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=a31c4466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c4466",
  null
  
)

export default component.exports